import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * This can be used to mock local storage for Edge and other browsers
 * that have disabled local storage setting
 */
export var STORAGE_MOCK = {
  _data: {},
  length: 0,
  setItem: function setItem(id, val) {
    return this._data[id] = String(val);
  },
  getItem: function getItem(id) {
    return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
  },
  removeItem: function removeItem(id) {
    return delete this._data[id];
  },
  clear: function clear() {
    return this._data = {};
  },
  key: function key(index) {
    var keys = Object.keys(this._data);
    return keys[index] || null;
  }
};
export var mockWindowStorage = function mockWindowStorage() {
  var storageToMock = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['localStorage', 'sessionStorage'];
  // Handle SSR environment where window is undefined
  var windowRef;
  var replacedWindowRef = false;
  if (typeof window === 'undefined') {
    // Ensure global exists and create window if needed
    if (typeof global !== 'undefined') {
      global.window = global.window || {};
      windowRef = global.window;
    } else {
      // Fallback for environments where global might not exist
      windowRef = {};
      replacedWindowRef = true;
    }
  } else {
    windowRef = window;
  }

  // Ensure windowRef is always defined and is an object
  if (!windowRef || _typeof(windowRef) !== 'object') {
    windowRef = {};
    replacedWindowRef = true;
  }

  // If we had to replace the window reference, reflect it back to global.window
  if (replacedWindowRef && typeof global !== 'undefined') {
    global.window = windowRef;
  }
  var _iterator = _createForOfIteratorHelper(storageToMock),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var storageToMockElement = _step.value;
      Object.defineProperty(windowRef, storageToMockElement, {
        value: _objectSpread({}, STORAGE_MOCK),
        configurable: true
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};